import { render } from "./ListCheckButton.vue?vue&type=template&id=3b85ef0c"
import script from "./ListCheckButton.vue?vue&type=script&lang=js"
export * from "./ListCheckButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__